import React from "react";
import PropTypes from "prop-types";
import { MSplitTabView, useMSplitTabView } from "components/Shared/MSplitTabView/";

const WrappedMSplitTabView = (props) => {
  const [state, functions] = useMSplitTabView(props);

  if (props.setControlMethods) props.setControlMethods(functions);

  return <MSplitTabView functions={functions} {...state} />;
};

WrappedMSplitTabView.propTypes = {
  tabs: PropTypes.array.isRequired, // documented in MSectionCollection as 'sections'
  setControlMethods: PropTypes.func, // ?
  onTabSplit: PropTypes.func, // documented on useMSplitTabView  
  defaultrightTabIds: PropTypes.array, // documented on useMSplitTabView
  firstChildInitialSize: PropTypes.string, // documented on useMSplitTabView
  getTabUnmountStatus: PropTypes.func, // documented on useMSplitTabView
  onTabUnmount: PropTypes.func, // documented on useMSplitTabView
  initialTabs: PropTypes.object, // undocumented data structure
};


export default WrappedMSplitTabView;